// extracted by mini-css-extract-plugin
export default {"wages_container":"wages_wages_container__5X+TH","title":"wages_title__xCMzk","table_container":"wages_table_container__Qz5ps"};